import { API } from "../../../api/constants"
import { authenticatedAxiosInstance } from "../../../auth/AuthenticatedAxios"

export const getAllObjectAddresses = () => authenticatedAxiosInstance.get(API + `/object/address`).then((res) => res.data)
